import { render, staticRenderFns } from "./appointmentsIndividualPanel.vue?vue&type=template&id=01bbf0b1&"
import script from "./appointmentsIndividualPanel.vue?vue&type=script&lang=js&"
export * from "./appointmentsIndividualPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports